import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import {HashLink} from 'react-router-hash-link';


class Alcohol extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
        <div>
            <Navbar head="Alcohol" />
            <div className="container" style={{marginTop:"60px"}}>
                <HashLink to="/faq#alcohol">
                    <button id="myBtn" title="FAQ">
                    <i class="fas fa-info-circle faqicon"></i> 
                        <p>  FAQ</p>
                    </button>
                </HashLink>
                
                
                <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                            <img className="img-fluid" src="/assests/images/educationAlcohol.png" alt="alcohol">
                            </img>

                        </div>
                    </div>
                <div className="content">
                    <h2>Alcohol</h2>
                    <p>Alcohol is a <b>psychoactive drug</b> which is the active ingredient in various kinds of 
                        drinks like wine, beer, and other kinds of hard liquor. 
                        Its <b>proportion varies differently in drinks</b> like wine, alcohol, beer, whiskey, etc.</p>

                    <p>Drinking too much on a single occasion or continuously over a period of
                         time can take a serious toll on the 
                        health and hence affect the body of an individual. </p>
                    <p><b>Alcohol overdose</b> occurs when there is a large amount of alcohol in the 
                        bloodstream which makes areas of the brain controlling basic life functions 
                        like breathing, heart rate and temperature control to begin to shut down</p>

                    <h4>Symptoms of alcohol overdose</h4>
                    <ul>
                        <li><p>Mental confusion</p></li>
                        <li><p>Vomiting</p></li>
                        <li><p>Difficulty remaining conscious</p></li>
                        <li><p>Dull responses like no gag reflex leading to choking</p></li>
                        <li><p>Permanent brain damage or death</p></li>
                        <li><p>Extremely low body temperature</p></li>
                        <li><p>Difficulty in breathing</p></li>
                    </ul>

                    <h4>Physical Effects of Alcohol</h4>
                    <ul>
                        <li><p>Interferes with brain’s communication paths, causes <b>disruption in mood and behaviour</b>. Makes it harder to think rationally and move with coordination</p></li>
                        <li><p>Can <b>cause irregular heart beats, high BP, stroke</b></p></li>
                        <li><p>Damage to liver leading to <b>cirrhosis and liver inflammation</b></p></li>
                        <li><p>Triggers the pancreas to produce toxic substances which leads to <b>improper digestion</b></p></li>
                    </ul>
                    <h4>Long Term Impacts</h4>
                    <ul>
                        <li><p>Cases of cancer may be associated with alcohol poisoning. Research indicates that the more alcohol a person consumes over a period of time- the higher risk of <b>alcohol associated cancer</b> like liver cancer, breast cancer, etc</p></li>
                        <li><p>Excessive drinking of alcohol weakens the immune system and makes the body an easier target for disease.</p></li>
                        <li><p>Drinking a lot on a single occasion slows the body's ability to ward off infections up to 24 hours of getting drunk.</p></li>
                        
                    </ul>

                    <h4>Other Effects of Long Term Alcohol Use</h4>
                    <ul>
                        <li><p>Memory loss</p></li>
                        <li><p>Severe mood swings</p></li>
                        <li><p>Dulled perception (especially vision)</p></li>
                        <li><p>Loss of attention span</p></li>
                        <li><p>Troubles in learning</p></li>
                        <li><p>Alcohol-induced disorders such as depression, anxiety, bipolar disorder, psychotic disorder. Withdrawal can aggravate these conditions further.</p></li>
                    </ul>
                </div>
            </div>
        </div>

        )
    }
}

export default Alcohol;